// import './avatar.scss';

export { default } from './Avatar';
export { default as template } from './avatar.tpl';
